 
import SecretsManager from 'aws-sdk/clients/secretsmanager';

const client = new SecretsManager({ region: 'us-east-1' });

export const loadSecrets = () =>
  new Promise((resolve, reject) => {
    client.getSecretValue({ SecretId: 'aws-secrets' }, (err, data) => {
      if (err) {
        return reject(err);
      }

      const secrets = JSON.parse(data.SecretString);
      Object.keys(secrets).forEach((key) => {
        process.env[key] = secrets[key];
      });
      process.env.SECRETS_READY = true;
      return resolve();
    });
  });
